/*
  This is a workaround for fixing scroll cutting top of the view
  when <EditorContent /> is mounted.

  This can be reproduced when Heading style format is applied on first
  text line and multiple lines of regular text sits below.

  Reproducible on Safari and Gnome Web (Ubuntu).
 */
import { useEffect, useState } from 'react';

export const useShowEditor = () => {
  const [showEditor, setShowEditor] = useState(false);

  const delayShow = async () => {
    setTimeout(() => {
      setShowEditor(true);
    }, 200);
  };

  useEffect(() => {
    delayShow();
  }, []);

  return showEditor;
};
